'use es6';

import PropTypes from 'prop-types';
import { OrderedSet } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IndexTableColumns = ({
  tableColumns,
  isModal
}) => /*#__PURE__*/_jsxs("colgroup", {
  children: [isModal ? null : /*#__PURE__*/_jsx("col", {
    style: {
      width: 70
    }
  }), tableColumns.map(({
    id,
    width
  }) => /*#__PURE__*/_jsx("col", {
    style: {
      width
    }
  }, `sales-content-index-table-column-${id}`)).toList()]
});
IndexTableColumns.propTypes = {
  tableColumns: PropTypes.instanceOf(OrderedSet).isRequired,
  isModal: PropTypes.bool.isRequired
};
export default IndexTableColumns;